export * from './SelectedLifestylesFloatingCounter.types';
export { default as SelectedLifestylesFloatingCounter } from './SelectedLifestylesFloatingCounter';
